var Eventable = require('Eventable');
var AppStatus = require('./../constant/AppStatus');
var Timer = require('./../../lib/Timer');
var utils = require('./../global/utils');
var isShopModeUser = utils.isShopModeUser;
var isEmpty = utils.isEmpty;
var jsonHandler = utils.jsonHandler;
var localStorage = window.localStorage;

var Asyn = function () {
    Eventable.call(this);
    this._sessionkey = null;
    this._app_status = null;
};
Asyn.prototype = Object.create(Eventable.prototype);
Asyn.prototype.start = function () {
    if (!localStorage) {
        return;
    }

    var sessionKey, appStatus;
    var self = this;
    self.setAppStatus('MIN');

    this._getStatusTimer = new Timer({
        onElapsed: function (cb) {
            sessionKey = jsonHandler.parse(localStorage.getItem("sessionKey"));
            appStatus = jsonHandler.parse(localStorage.getItem("openState"));
            if (self._app_status !== appStatus) {
                self._app_status = appStatus;
                self.triggerEvent("appStatusChange", appStatus);
            }
            self._sessionkey = sessionKey;
            self.triggerEvent("sessionCheckChange", sessionKey);
            cb();
        },
        duration: 1000
    });
    this._getStatusTimer.start();
};
Asyn.prototype.getSession = function () {
    return this._sessionkey;
};
Asyn.prototype.getAppStatus = function () {
    return this._app_status;
};
Asyn.prototype.setSession = function (session) {
    if (!localStorage) {
        return;
    }

    if (session.user_id) {
        this._sessionkey = session.user_id + '@' + session.user_source;
        if (isShopModeUser(session) && !isEmpty(session.shop_id) && !isEmpty(session.shop_source)) {
            this._sessionkey += '@@' + session.shop_id + '@' + session.shop_source;
        }
        localStorage.setItem("sessionKey", JSON.stringify(this._sessionkey));
    }
};
Asyn.prototype.setAppStatus = function (status) {
    if (!localStorage) {
        return;
    }

    this._app_status = status;
    localStorage.setItem("openState", JSON.stringify(this._app_status));
};
Asyn.prototype.clearStatus = function (name) {
    if (!localStorage) {
        return;
    }
    localStorage.removeItem(name);
};
Asyn.prototype.stop = function () {
    this._getStatusTimer && this._getStatusTimer.stop();
};

module.exports = new Asyn();
